import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Represents the view for filtering products by bet shop.
 * Extends the JetView class from webix-jet.
 */
export default class FilterProductsThirdByBetShopView extends JetView {
    /**
     * Configures the form view for filtering products by bet shop.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"),
                    labelPosition: 'top',
                    placeholder: _('ID'),
                },
            ],
        };

        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProductsThird',
                    id: 'ProductsThird',
                    label: _('Producto Terceros'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        this.app.callEvent('addProductsThird:button', [{}]);
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        this.app.callEvent('productsThird:filter', [filterdata]);
                    },
                },
            ],
        };

        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the form and sets up the options for the ProductsThird combo box.
     */
    init() {
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetProductsThirdSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! ');
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text);
                    $$('ProductsThird').define('options', resp.Data);
                    $$('ProductsThird').refresh();
                },
            });
    }
}

// FILE DOCUMENTED
